import { createGtm as Gtm } from '@outputinc/o-analytics'

const gtmContainerId = import.meta.env.VITE_OUTPUT_GTM_CONTAINER_ID
const gtmEnvironmentId = import.meta.env.VITE_OUTPUT_GTM_ENV_ID
const gtmAuthId = import.meta.env.VITE_OUTPUT_GTM_AUTH_ID

// query params for test environments
const queryParams = {
  gtm_auth: gtmAuthId,
  gtm_preview: gtmEnvironmentId,
  gtm_cookies_win: 'x'
}

const gtmClient = Gtm({
  id: gtmContainerId,
  ...(gtmEnvironmentId && { queryParams })
})

export default gtmClient
